var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestDesktopSave = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 20,
  viewBox: "0 0 10 20",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2.1 7.571V1.9L.333 0h9.334L7.9 1.9v5.67l2.1 2.86v.999H5.83v5.586L5.5 19 5 20l-.5-1-.333-1.985V11.43H0v-.999z"
})));
export default SvgPinterestDesktopSave;